import {
    createDevice,
    createGroup,
    deleteGroup,
    deleteUniversalLicense,
    generateLicenses,
    revokeLicense,
    updateDevice,
    updateGroup,
    updateGroupMembers,
    updateGroupParent,
    updateLicense,
    updatePolicy,
    updateUniversalLicense,
} from "@dashboard/devices/store";
import { isAnyOf, ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

import { eventsApi } from ".";

const eventCreatingActions = isAnyOf(
    createDevice.fulfilled,
    createGroup.fulfilled,
    deleteGroup.fulfilled,
    updateGroup.fulfilled,
    updateGroupParent.fulfilled,
    updateGroupMembers.fulfilled,
    updatePolicy.fulfilled,
    updateLicense.fulfilled,
    revokeLicense.fulfilled,
    generateLicenses.fulfilled,
    updateDevice.fulfilled,
    updateUniversalLicense.fulfilled,
    deleteUniversalLicense.fulfilled,
);

export const initEventsCacheListener = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        matcher: eventCreatingActions,
        effect: (_action, listenerApi) => {
            listenerApi.dispatch(eventsApi.util.invalidateTags(["ActivityReport", "Events"]));
        },
    });
};
